import type { RouteRecordRaw } from 'vue-router'
import oidcAuth from '@/auth/oidcAuth'
import HomePage from '@/v2/pages/HomePage.vue'
import ExportsCegidAdminPage from '@/v2/pages/ExportsCegidAdminPage.vue'
import CommercialDashboardPage from '@/v2/pages/CommercialDashboardPage.vue'
import ReassignClientsAdminPage from '@/v2/pages/ReassignClientsAdminPage.vue'
import QuotesExportAdminPage from '@/v2/pages/QuotesExportAdminPage.vue'

/**
 * Routes V2 — chemins propres (pas de préfixe /v2/*) avec leurs propres composants
 * sous front/src/v2/. Toutes taggées `meta.version: 'v2'` :
 *   - le guard router redirige vers la home V1 si l'utilisateur est en mode v1
 *   - le guard router redirige vers la home V1 si le flag LAYOUT_APY est absent
 *   - App.vue sélectionne ApyLayout sur ces routes
 *
 * Convention : si une route V1 a un équivalent V2, choisir un path différent
 * (ex: /search V1 vs /recherche V2) — pas de partage de path entre versions.
 *
 * Note : /recherche est intentionnellement absent d'ici — c'est une route globale
 * gérée par le routeur principal, accessible en V1 et V2 via le flag OMNISEARCH.
 */
export const v2Routes: RouteRecordRaw[] = [
  {
    path: '/accueil',
    name: 'v2-home',
    component: HomePage,
    meta: {
      authName: oidcAuth.authName,
      hideRightSidebar: true,
      version: 'v2',
    },
  },
  {
    path: '/admin/exports-cegid',
    name: 'v2-admin-exports-cegid',
    component: ExportsCegidAdminPage,
    meta: {
      authName: oidcAuth.authName,
      hideRightSidebar: true,
      version: 'v2',
      title: 'Exports Cegid (TRA)',
      requiresSuperAdmin: true,
    }
  },
  {
    path: '/admin/reassign-clients',
    name: 'v2-admin-reassign-clients',
    component: ReassignClientsAdminPage,
    meta: {
      authName: oidcAuth.authName,
      hideRightSidebar: true,
      version: 'v2',
      title: 'Réassignation clients',
      requiresSuperAdmin: true,
    },
  },
  {
    path: '/admin/exports-devis',
    name: 'v2-admin-exports-devis',
    component: QuotesExportAdminPage,
    meta: {
      authName: oidcAuth.authName,
      hideRightSidebar: true,
      version: 'v2',
      title: 'Export devis (lignes)',
      requiresSuperAdmin: true,
    },
  },
  {
    path: '/commercial/dashboard',
    name: 'commercial-dashboard',
    component: CommercialDashboardPage,
    meta: {
      authName: oidcAuth.authName,
      hideRightSidebar: true,
      version: 'global',
      requiresFeatureFlag: 'CUSTOMER_WALLET',
    },
  },
]
